<script setup>
import {useSeoScore} from "@/composables/useSeoScore.js";
import { computed } from "vue";
import OptimisationScoreBars from "@/components/seo-score/partials/OptimisationScoreBars.vue";
import {kitName, platformName} from "@/composables/useLocalDomains";

const { optimisationScore } = useSeoScore();

const filledBars = computed(() => Math.round(optimisationScore.value / 2));
</script>

<template>
  <div class="tw-border tw-border-neutral-300 tw-rounded-xl tw-p-5 tw-flex tw-flex-col tw-gap-y-6">
    <div class="tw-flex tw-justify-between tw-items-center">
      <span class="tw-text-neutral-900 tw-text-2xl">
        Website Quality Score
      </span>
    </div>
    <span class="tw-text-neutral-700 tw-text-sm">
      This shows how well your website is optimised in {{ platformName }} for search, local, and AI visibility. {{ kitName }} improves your score every month without you lifting a finger. And if you want to move even faster, {{ kitName }} shows you exactly what to do next to push it higher.
    </span>

    <div class="tw-flex tw-justify-between tw-h-14">
      <div class="tw-relative tw-h-14">
        <OptimisationScoreBars :filled-bars="filledBars" />
      </div>
    </div>
  </div>
</template>
